import { render } from "./Pricing1.vue?vue&type=template&id=7f19b635"
import script from "./Pricing1.vue?vue&type=script&lang=js"
export * from "./Pricing1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__